// extracted by mini-css-extract-plugin
export var messageSideLeft = "_pb-1";
export var messageSideRight = "_pb-2";
export var subscribeToBackInStockBubbleContainer = "_pb-0";